// constants
export const VALID_COOKIES = [
    'utm_source',
    'utm_medium',
    'utm_term',
    'utm_content',
    'utm_campaign',
    'url_signupstart',
    'url_referrer',
    'landingpage',
    'deal',
    'gclid',
    'fbcid',
];

export const VALID_QUERYSTRINGS = VALID_COOKIES.concat([
    'email',
    'phone',
    'name',
    'selected_service',
    'lead',
    'ref',
    'crtid',
    'segid',
    'eid',
    'ls_lb',
    'ls_db',
    'formName',
    'from_react_web',
]);

export const VALID_FORM_NAMES = ['non-mowing'];
